<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar cad color="primary" dark dense flat>
            <v-toolbar-title class="subheading">{{
              $route.meta.title
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-select
                    :error-messages="errors.collect('distributor')"
                    :items="distributors"
                    data-vv-name="distributor"
                    label="Distribuidor"
                    no-data-text="Datos no disponibles"
                    required
                    v-model="form.distId"
                    v-on:change="onChangeDistributor"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    :error-messages="errors.collect('laboratory')"
                    :items="laboratories"
                    data-vv-name="laboratory"
                    label="Laboratorio"
                    no-data-text="Datos no disponibles"
                    required
                    v-model="form.labId"
                    v-on:change="onChangeLaboratory"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>

                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('invoice')"
                    data-vv-name="invoice"
                    label="Factura"
                    required
                    v-model="form.invoice"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('orderNumber')"
                    data-vv-name="orderNumber"
                    label="# Pedido"
                    required
                    v-model="form.orderNumber"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-input
                    class="v-text-field-numeric v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light"
                    label="# CIF"
                  >
                    <vue-numeric
                      separator=","
                      v-bind:minus="false"
                      v-bind:precision="2"
                      v-model="form.cif"
                    ></vue-numeric>
                  </v-input>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('packageNumber')"
                    data-vv-name="packageNumber"
                    label="# Bulto"
                    required
                    v-model="form.packageNumber"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('controlNumber')"
                    data-vv-name="controlNumber"
                    label="# Control"
                    required
                    v-model="form.controlNumber"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex md6 xs12>
                  <v-dialog
                    :return-value.sync="form.receivedDate"
                    full-width
                    ref="dialog"
                    v-model="modalExpdate"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :error-messages="errors.collect('receivedDate')"
                        append-icon="event"
                        data-vv-name="receivedDate"
                        label="Fecha de recepción"
                        readonly
                        v-model="form.receivedDate"
                        v-on="on"
                        v-validate="'required'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-es"
                      scrollable
                      v-model="form.receivedDate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="modalExpdate = false"
                        color="primary"
                        flat
                        text
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="$refs.dialog.save(form.receivedDate)"
                        color="primary"
                        flat
                        text
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    :error-messages="errors.collect('clientVisible')"
                    :items="clientVisible"
                    data-vv-name="clientVisible"
                    label="Visible para"
                    no-data-text="Datos no disponibles"
                    required
                    v-model="form.visible"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>
                <v-flex md12 xs12>
                  <v-textarea
                    data-vv-name="address"
                    label="Observaciones"
                    v-model="form.observations"
                  ></v-textarea>
                </v-flex>
                <v-flex m12 xs12>
                  <v-data-table
                    :headers="headers"
                    :items="InvoiceProducts"
                    class="elevation-0"
                    hide-actions
                    no-data-text="Datos no disponibles"
                    no-results-text="No se encontraron registros coincidentes"
                  >
                    <template slot="items" slot-scope="props">
                      <app-product-row
                        :index="getRowItemIndex(props.item.rowKey)"
                        :key="props.item.rowKey"
                        :productCatalog="products"
                        :row="props.item"
                      ></app-product-row>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex md12 xs12>
                  <v-btn @click="addProduct" color="primary">+</v-btn>
                </v-flex>
                <v-flex md12 xs12>
                  <v-btn @click="submit" color="success">Enviar</v-btn>
                  <v-btn
                    @click="$router.push('/facturas/listado')"
                    color="error"
                    >Cancelar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
        <message
          :key="dialog.key"
          :options="dialog"
          v-on:close="dialog.show = false"
        ></message>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductRow from './ProductRow.vue'
import message from './../dialog/Message'
export default {
  props: {
    form: {
      type: Object,
      default() {
        return {
          labId: '',
          distId: '',
          invoice: '',
          orderNumber: '',
          cif: '',
          packageNumber: '',
          controlNumber: '',
          receivedDate: '',
          observations: '',
          visible: '',
          batches: [],
        }
      },
    },
  },
  components: {
    'app-product-row': ProductRow,
    message,
  },
  computed: {
    ...mapGetters({
      InvoiceProducts: 'invoices/emptyItems',
    }),
  },
  mounted() {
    this.$store.dispatch('invoices/resetEmptyItems')
  },

  data() {
    return {
      modalExpdate: false,
      laboratories: [],
      distributors: [],
      clientVisible: [
        { text: 'AMBOS', value: 'Ambos' },
        { text: 'SOLO LABORATORIO', value: 'Laboratorio' },
        { text: 'SOLO DISTRIBUIDOR', value: 'Distribuidor' },
      ],
      products: [],
      headers: [
        { text: 'Producto', align: 'left', sortable: false },
        { text: '# Lote', width: '15%', align: 'left', sortable: false },
        { text: 'Reg Sanitario', align: 'left', sortable: false },
        { text: 'Presentacion', width: '15%', align: 'left', sortable: false },
        { text: 'Expiración', align: 'left', sortable: false },
        { text: 'Certificados', align: 'left', sortable: false },
        { text: 'Estatus', align: 'left', sortable: false },
        { text: 'Acciones', align: 'left', sortable: false },
      ],
      dialog: {
        show: false,
        key: 0,
      },
    }
  },
  created() {
    this.$store.dispatch('distributors/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.distributors.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    if ('id' in this.$route.params) {
      this.$store
        .dispatch('invoices/getById', {
          id: this.$route.params.id,
        })
        .then(response => {
          if (response) {
            this.form = Object.assign(this.form, {
              id: response.id,
              labId: response.lab_invoices.id,
              distId: response.dist_invoices.id,
              invoice: response.invoiceNumber,
              orderNumber: response.orderNumber,
              cif: response.cif,
              packageNumber: response.packageNumber,
              controlNumber: response.controlNumber,
              receivedDate: response.receivedDate,
              observations: response.observations,
              visible: response.clientVisible,
              batches: [],
            })

            this.onChangeLaboratory(this.form.labId)
            this.onChangeDistributor(this.form.distId)

            /* products  */
            Object.keys(response.InvoiceProductBatches).map(objectKey => {
              var object =
                response.InvoiceProductBatches[objectKey].ProductBatch
              this.InvoiceProducts.push({
                rowKey: this.getRowKey(),
                product: {
                  name: object.product.name,
                  id: object.product.id,
                },
                batch: {
                  name: object.batchNumber,
                  id: object.id,
                  batchId: object.id,
                  expirationDate: object.expirationDate,
                  fxFormula: object.fxFormula,
                  sanitaryReg: object.sanitaryReg,
                  certificate: object.certificate,
                  batchStatus: object.batchStatus,
                  statusLabel: object.statusLabel,
                  totalCertificate: object.total_certificate,
                },
                sanitaryReg: object.sanitaryReg,
              })
            })
          } else {
            this.$router.push('/facturas/listado')
          }
        })
    }
  },
  methods: {
    getRowKey() {
      const numeric = Math.random()
        .toString(36)
        .substr(2, 12)
      return `key-${numeric}`
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.form.batches = []
          for (let index in this.InvoiceProducts) {
            if (this.InvoiceProducts[index].batch) {
              this.form.batches.push(this.InvoiceProducts[index].batch.batchId)
            }
          }

          this.$store.dispatch('invoices/save', this.form).then(response => {
            if (response.status === 200) {
              if (this.form.id) {
                this.dialog = {
                  message: 'Los datos fueron actualizados exitosamente',
                  color: 'primary',
                  show: true,
                  key: this.dialog.key + 1,
                }
              } else {
                this.$router.push('/facturas/listado')
              }
            } else {
              this.dialog = {
                message: response.data.error,
                color: 'error',
                show: true,
                key: this.dialog.key + 1,
              }
            }
          })
        }
      })
    },

    addProduct() {
      this.InvoiceProducts.push({
        rowKey: this.getRowKey(),
        product: null,
        batch: null,
      })
    },

    getRowItemIndex(rowKey) {
      let itemIndex = 0
      for (let index = 0; index < this.InvoiceProducts.length; index++) {
        if (this.InvoiceProducts[index].rowKey === rowKey) {
          itemIndex = index
          break
        }
      }
      return itemIndex
    },

    onChangeLaboratory(labId) {
      this.products = []
      this.$store.dispatch('invoices/resetEmptyItems')
      this.key = this.key + 1
      this.$store
        .dispatch('products/getBasicListByLaboratory', { labId: labId })
        .then(data => {
          for (let index = 0; index < data.length; index += 1) {
            this.products.push({
              name: data[index].product.name,
              id: data[index].product.id,
            })
          }
        })
    },
    onChangeDistributor(id) {
      this.laboratories = []
      this.$store.dispatch('distributors/getById', { id: id }).then(data => {
        const labs = data.laboratories
        for (let index = 0; index < labs.length; index += 1) {
          this.laboratories.push({
            text: labs[index].name,
            value: labs[index].id,
          })
        }
      })
    },
  },
}
</script>
<style scope="css">
.v-text-field-numeric .v-label {
  position: absolute !important;
  transform: translateY(-18px) scale(0.75);
}
</style>
